import * as React from "react";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {deleteFileExpertData, uploadFileExpertData} from "../../../actions";
import {Guid} from "../../Utils";
import {Label} from "react-bootstrap";

const FileAnswer = ({item}) => {
    const form_type = useSelector((state: any) => state.forms.form_type);
    const dispatch = useDispatch();
    const [needFile, setNeedFile] = useState(false);

    useEffect(() => {
        if(!item.files.length) {
            setNeedFile(true);
        }
    }, [item.files]);

    return <>
        {
            item.files && item.files?.map((file_item) => (
                <div className="answer-file">
                    <a
                        className="answer-file__link"
                        key={`File.${file_item.id}`}
                        href={file_item.url}
                    >
                        {file_item.name}
                    </a>

                    {
                        // @ts-ignore
                        !item.is_sent ? <Label
                            className="answer-file__delete"
                            bsStyle="danger"
                            onClick={() => {
                                deleteFileExpertData(form_type, item.id, file_item.id)(dispatch);
                            }}
                        >
                            x
                        </Label> : null
                    }
                </div>
            ))
        }

        {
            !item.is_sent ? <>
                {
                    needFile ? <input
                        type="file"
                        name="files"
                        multiple={false}
                        onChange={(e) => {
                            const form_data = new FormData();
                            form_data.append('file', e.target.files[0]);
                            form_data.append('fileId', Guid.newGuid());

                            uploadFileExpertData(form_data, form_type, item.id)(dispatch);
                            setNeedFile(false);
                        }}
                    /> : null
                }

                {
                    !needFile ? <button
                        title="Добавить еще"
                        type="button"
                        onClick={() => setNeedFile(true)}
                    >
                        Добавить еще
                    </button> : null
                }
            </> : null
        }
    </>
}

export default FileAnswer;